import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n";
import { Reveal } from "./Reveal";

export function Founder() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="founder" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* image */}
        <div ref={ref} className="lg:col-span-6 order-1">
          <Reveal>
            <div className="editorial-img relative rounded-[2px] aspect-[4/5] max-w-[520px]">
              <motion.img
                style={{ y: imgY, scale: 1.12 }}
                src="/images/founder.webp"
                alt={t.founder.name}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>

        {/* text */}
        <div className="lg:col-span-6 order-2">
          <Reveal delay={0.15}>
            <p className="eyebrow mb-6">{t.founder.eyebrow}</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mb-2">
              {t.founder.name}
            </h2>
            <p className="font-display italic text-2xl md:text-3xl text-[var(--gold-dark)] mb-8">
              {t.founder.title}
            </p>
            <div className="space-y-5 text-[var(--ink-2)] text-base md:text-lg leading-relaxed max-w-xl">
              <p>{t.founder.p1}</p>
              <p>{t.founder.p2}</p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg">
              {t.founder.stats.map((s, i) => (
                <div key={i} className="border-t border-[var(--gold)]/40 pt-4">
                  <div className="font-display text-4xl md:text-5xl leading-none">{s.k}</div>
                  <div className="eyebrow mt-2 text-[10px] normal-case tracking-widest">{s.v}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
